// İSG uzmanı portalı — Kontrol İtemları kataloğu TanStack Query anahtarları (api-contract §25,
// tenant-scoped). Liste anahtarı parametreleri içerir (filtre/sayfa değişince yeniden çeker);
// invalidasyon önek (prefix) ile: `['control-items','list']` tüm liste sorgularını kapsar. `options`
// = permit-tipi formundaki kontrol seçicisini besleyen tek-sayfa çekim.
//
// Katalog erişimi İş İzni Tipleri (§22) ile **aynı grant** altındadır (`permit-types`; D3) — ayrı
// erişim sondası yoktur; katalog ekranları `usePermitTypesAccess` (permitTypesAccess.ts) kapısı
// altındadır. İzinde işaretleme (§25.3) ise `permits` modülü altındadır (permitsKeys.detail).

import type { ControlItemListParams } from '@isgportal/shared';

export const controlItemsKeys = {
  /** Tüm kontrol itemı sorgularının kök öneki — invalidasyon için. */
  all: () => ['control-items'] as const,
  /** Tüm liste sorgularının öneki (filtre/sayfa varyantlarını kapsar). */
  list: () => ['control-items', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: ControlItemListParams) => ['control-items', 'list', params] as const,
  /** Permit-tipi formundaki kontrol seçicisi için katalog (tek sayfa). */
  options: () => ['control-items', 'options'] as const,
} as const;
